import { render } from "./OrderViewTable.vue?vue&type=template&id=539cf3d8&scoped=true"
import script from "./OrderViewTable.vue?vue&type=script&lang=js"
export * from "./OrderViewTable.vue?vue&type=script&lang=js"

import "./OrderViewTable.vue?vue&type=style&index=0&id=539cf3d8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539cf3d8"]])

export default __exports__